<div class="container-fluid main-widget">
    <div class="card title-line mb-3">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h2 class="mb-0">Catálogo de Empresas</h2>
            <button class="btn btn-primary" (click)="openCreate()" *ngIf="formMode === null">
                <i class="fa fa-plus me-1"></i> Nueva Empresa
            </button>
        </div>
    </div>

    <!-- Formulario de Empresa -->
    <div class="card mb-4" *ngIf="formMode !== null">
        <div class="card-header">
            <h5 class="mb-0">{{ formMode === 'create' ? 'Registrar Empresa' : 'Editar Empresa' }}</h5>
        </div>
        <div class="card-body">
            <div class="row g-3">
                <div class="col-md-3 col-12">
                    <label class="form-label">Clave/Identificador *</label>
                    <input type="text" class="form-control text-uppercase" [(ngModel)]="currentEmpresa.rfc"
                        maxlength="13" [disabled]="formMode === 'edit'" placeholder="Identificador único">
                </div>
                <div class="col-md-5 col-12">
                    <label class="form-label">Nombre de la Empresa *</label>
                    <input type="text" class="form-control" [(ngModel)]="currentEmpresa.razon_social"
                        placeholder="Nombre de empresa">
                </div>
                <div class="col-md-4 col-12">
                    <label class="form-label">Email de Contacto</label>
                    <input type="email" class="form-control" [(ngModel)]="currentEmpresa.email_contacto"
                        placeholder="contacto@empresa.com">
                </div>
                <div class="col-md-10 col-12">
                    <label class="form-label">Descripción</label>
                    <input type="text" class="form-control" [(ngModel)]="currentEmpresa.domicilio_fiscal"
                        placeholder="Descripción breve de la empresa">
                </div>
                <div class="col-md-2 col-12">
                    <label class="form-label">Estatus</label>
                    <select class="form-select" [(ngModel)]="currentEmpresa.status">
                        <option [ngValue]="1">Activo</option>
                        <option [ngValue]="0">Inactivo</option>
                    </select>
                </div>
            </div>
            <div class="mt-3 d-flex gap-2">
                <button class="btn btn-success" (click)="saveEmpresa()"><i class="fa fa-save me-1"></i> Guardar</button>
                <button class="btn btn-outline-secondary" (click)="cancelForm()">Cancelar</button>
            </div>
        </div>
    </div>

    <!-- Tabla de Empresas -->
    <div class="card">
        <div class="card-body p-0">
            <div *ngIf="loading" class="text-center p-4">
                <span class="spinner-border text-primary"></span>
            </div>
            <table class="table table-hover mb-0" *ngIf="!loading">
                <thead class="table-light">
                    <tr>
                        <th>Clave/ID</th>
                        <th>Nombre</th>
                        <th>Descripción</th>
                        <th>Email</th>
                        <th>Estatus</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let emp of empresas">
                        <!-- Empresa principal -->
                        <tr>
                            <td><strong>{{ emp.rfc }}</strong></td>
                            <td>{{ emp.razon_social }}</td>
                            <td>{{ emp.domicilio_fiscal ?? '—' }}</td>
                            <td>{{ emp.email_contacto ?? '—' }}</td>
                            <td>
                                <span class="badge" [class.bg-success]="emp.status == 1"
                                    [class.bg-secondary]="emp.status != 1">
                                    {{ emp.status == 1 ? 'Activo' : 'Inactivo' }}
                                </span>
                            </td>
                            <td>
                                <div class="d-flex gap-1 flex-wrap">
                                    <button class="btn btn-sm btn-outline-primary" (click)="openEdit(emp)"
                                        title="Editar">
                                        <i class="fa fa-edit"></i>
                                    </button>
                                    <button *ngIf="false" class="btn btn-sm btn-outline-info" (click)="toggleSubForm(emp.rfc)"
                                        title="Gestionar grupo">
                                        <i class="fa fa-sitemap"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-danger" (click)="deleteEmpresa(emp)"
                                        title="Eliminar">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <!-- Sub-empresas del grupo -->
                        <ng-container *ngIf="emp.subempresas?.length > 0">
                            <tr *ngFor="let sub of emp.subempresas" class="table-light">
                                <td class="ps-4 text-muted"><i class="fa fa-level-down me-1"></i>{{ sub.rfc_secundario
                                    }}</td>
                                <td colspan="4" class="text-muted">{{ sub.alias ?? '(sub-empresa)' }}</td>
                                <td></td>
                            </tr>
                        </ng-container>
                        <!-- Formulario para agregar sub -->
                        <tr *ngIf="showSubForm && activeMaestro === emp.rfc">
                            <td colspan="6" class="bg-light">
                                <div class="d-flex gap-2 align-items-center p-1">
                                    <input type="text" class="form-control form-control-sm"
                                        [(ngModel)]="newSub.rfc_secundario" placeholder="RFC secundario"
                                        style="max-width:160px">
                                    <input type="text" class="form-control form-control-sm" [(ngModel)]="newSub.alias"
                                        placeholder="Alias (opcional)">
                                    <button class="btn btn-sm btn-success" (click)="addSub()"><i class="fa fa-plus"></i>
                                        Agregar</button>
                                    <button class="btn btn-sm btn-outline-secondary"
                                        (click)="showSubForm = false">Cancelar</button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="empresas.length === 0">
                        <td colspan="6" class="text-center text-muted p-4">No hay empresas registradas.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>